import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ImageUploader from "react-images-upload";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionDiscMode = [
      { value: "fix", label: "مبلغ ثابت" },
      { value: "percent", label: "درصد" },
]

class ChangePackageinsurance extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  packageinsurance_id: "",
                  packageinsurance_disctitle: "",
                  packageinsurance_discamount: "",
                  packageinsurance_amount: "",
                  packageinsurance_logo: "",
                  packageinsurance_t_logo: "",
                  packageinsurance_desc: "",
                  packageinsurance_extracoverage: "",
                  packageinsurance_coverage: "",
                  packageinsurance_date_start: "",
                  packageinsurance_date_end: "",
                  selectedFieldinsurance: "",
                  selectedFilterFieldinsurance: "",
                  selectedCompany: "",
                  selectedFilterCompany: "",
                  packageinsurance_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  orderBy: "packageinsurance_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newManagDiscount: true,
                  optionCompany: [],
                  optionFilterCompany: [],
                  optionFieldinsurance: [],
                  optionFilterFieldinsurance: [],
                  packageinsurance_title: '',
                  openDialog: false,
                  picturesRequestReady: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }
      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }
      handleChangeDiscAmount = (event) => {
            this.setState({ packageinsurance_discamount: event })
      }

      handleChangeDiscTitle = (event) => {
            this.setState({ packageinsurance_disctitle: event.target.value })
      }

      handleChangeAmount = (event) => {
            this.setState({ packageinsurance_amount: event })
      }



      handleChangeDesc = (event) => {
            this.setState({ packageinsurance_desc:  event.target.value })
      }

      handleChangeExtraCovarage = (event) => {
            this.setState({ packageinsurance_extracoverage: event.target.value })
      }


      handleChangeCovarage = (event) => {
            this.setState({ packageinsurance_coverage: event.target.value })
      }

      setSelectedDayStart = (event) => {
            this.setState({ packageinsurance_date_start: event }, () => {})
      }

      setSelectedDayEnd = (event) => {
            console.log(event)
            this.setState({ packageinsurance_date_end: event }, () => {})
      }

      clearDeyStart = (event) => {
            this.setState({ packageinsurance_date_start: "" }, () => {})
      }
      clearDeyEnd = (event) => {
            this.setState({ packageinsurance_date_end: "" }, () => {})
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance, fieldinsurance_logo_url: selectedFieldinsurance.logo })
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterManagDiscount()
            })
      }
      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, company_logo_url: selectedCompany.logo })
      }


      handleGender = (event) => {
            this.setState({ packageinsurance_title:  event.target.value })
      }

      handleFilterCompany = (selectedFilterCompany) => {
            this.setState({ selectedFilterCompany: selectedFilterCompany }, () => {
                  this.filterManagDiscount()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ packageinsurance_deactive: "0" })
            } else {
                  this.setState({ packageinsurance_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {

            var jdate1 = "",
                  jdate2 = ""
            if (row2.packageinsurance_date_start !== "") {
                  var varmoment1 = Moment(row2.packageinsurance_date_start, "YYYY-M-D HH:mm:ss")
                  var date1 = new Date(parseInt(varmoment1.format("x")))
                  jdate1 = new JDate(date1)
                  jdate1 = { day: parseInt(jdate1.format("DD")), month: parseInt(jdate1.format("MM")), year: parseInt(jdate1.format("YYYY")) }
            }
            if (row2.packageinsurance_date_end !== "") {
                  var varmoment2 = Moment(row2.packageinsurance_date_end, "YYYY-M-D HH:mm:ss")
                  var date2 = new Date(parseInt(varmoment2.format("x")))
                  var jdate2 = new JDate(date2)
                  jdate2 = { day: parseInt(jdate2.format("DD")), month: parseInt(jdate2.format("MM")), year: parseInt(jdate2.format("YYYY")) }
            }
            this.setState(
                  {
                        packageinsurance_id: row2.packageinsurance_id,
                        packageinsurance_disctitle: row2.packageinsurance_disctitle,
                        packageinsurance_discamount: row2.packageinsurance_discamount,
                        packageinsurance_amount: row2.packageinsurance_amount,
                        packageinsurance_logo: row2.packageinsurance_logo,
                        packageinsurance_t_logo: row2.packageinsurance_t_logo,
                        packageinsurance_desc: row2.packageinsurance_desc,
                        packageinsurance_extracoverage: row2.packageinsurance_extracoverage,
                        packageinsurance_coverage: row2.packageinsurance_coverage,
                        packageinsurance_date_start: jdate1,
                        packageinsurance_date_end: jdate2,
                        selectedFieldinsurance: {
                              value: row2.packageinsurance_fieldinsurance_id,
                              label: row2.fieldinsurance_fa,
                              logo: row2.fieldinsurance_logo_url,
                        },
                        selectedCompany: { value: row2.packageinsurance_company_id, label: row2.company_name, logo: row2.company_logo_url },
                        packageinsurance_title: row2.packageinsurance_title,

                        packageinsurance_deactive: row2.packageinsurance_deactive,
                        company_logo_url: row2.company_logo_url,
                        fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                        newManagDiscount: false,
                  },
                  () => {}
            )
      }

      newManagDiscount = (event) => {
            this.setState({
                  packageinsurance_id: "",
                  packageinsurance_disctitle: "",
                  packageinsurance_discamount: "",
                  packageinsurance_amount: "",
                  packageinsurance_logo: "",
                  packageinsurance_desc: "",
                  packageinsurance_extracoverage: "",
                  packageinsurance_coverage: "",
                  packageinsurance_date_start: "",
                  packageinsurance_date_end: "",
                  selectedFieldinsurance: "",
                  selectedCompany: "",
                  packageinsurance_title: '',
                  packageinsurance_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  newManagDiscount: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                                    self.getManagDiscount()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deletePackageinsurance = () => {
            const { packageinsurance_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getManagDiscount()
                              self.newManagDiscount()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_packageinsurance")
            fd.append("packageinsurance_id", packageinsurance_id)

            xhttp.open("POST", `${constants.BASE_URL}/packageinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getManagDiscount() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                               })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_packageinsurance")

            xhttp.open("POST", `${constants.BASE_URL}/packageinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه شرکت های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, optionFilterCompany: Company1, selectedFilterCompany: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState(
                                    {
                                          optionFieldinsurance: Company,
                                          optionFilterFieldinsurance: Company1,
                                          selectedFilterFieldinsurance: Company1[0],
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }
      uploadPicDelivery = (mode) => {
            const {
                  packageinsurance_title,
                  packageinsurance_disctitle,
                  packageinsurance_discamount,
                  packageinsurance_amount,
                  packageinsurance_desc,
                  packageinsurance_extracoverage,
                  packageinsurance_coverage,
                  packageinsurance_date_start,
                  packageinsurance_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  packageinsurance_deactive,
                  picturesRequestReady,
            } = this.state
            if (
                selectedFieldinsurance != "" &&
                selectedCompany != "" &&
                packageinsurance_title != "" &&
                packageinsurance_discamount != "" &&
                packageinsurance_amount != "" &&
                packageinsurance_desc != "" &&
                packageinsurance_coverage != ""&&
                packageinsurance_extracoverage != ""
            ) {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewManagDiscount(arr.data["image_code"])
                                          } else {
                                                self.changeManagDiscount(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر شرکت بیمه")
                        fd.append("image_desc", "تصویر شرکت بیمه" )
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                            "progress",
                            function(evt) {
                                  if (evt.lengthComputable) {
                                        var percentComplete = evt.loaded / evt.total
                                        self.setState({
                                              percent: percentComplete * 100,
                                        })
                                  }
                            },
                            false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewManagDiscount("")
                        } else {
                              this.changeManagDiscount("")
                        }
                  }
            } else {
                  console.log( selectedFieldinsurance ,
                      selectedCompany ,
                      packageinsurance_title ,
                      packageinsurance_discamount,
                      packageinsurance_amount,
                      packageinsurance_desc,
                      packageinsurance_coverage,
                      packageinsurance_extracoverage )
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewManagDiscount = (imageCode) => {
            const {
                  packageinsurance_title,
                  packageinsurance_discamount,
                  packageinsurance_disctitle,
                  packageinsurance_amount,
                  packageinsurance_desc,
                  packageinsurance_extracoverage,
                  packageinsurance_coverage,
                  packageinsurance_date_start,
                  packageinsurance_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  packageinsurance_deactive,
            } = this.state
            if (
                  selectedFieldinsurance != "" &&
                  selectedCompany != "" &&
                  packageinsurance_title != "" &&
                packageinsurance_discamount != "" &&
                packageinsurance_amount != "" &&
                  packageinsurance_desc != "" &&
                packageinsurance_extracoverage != "" &&
                packageinsurance_coverage != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getManagDiscount()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_packageinsurance")
                  fd.append("packageinsurance_disctitle", packageinsurance_disctitle)
                  fd.append("packageinsurance_discamount", packageinsurance_discamount)
                  fd.append("packageinsurance_amount", packageinsurance_amount)
                  fd.append("packageinsurance_logo", imageCode)
                  fd.append("packageinsurance_desc", packageinsurance_desc)
                  fd.append("packageinsurance_extracoverage", packageinsurance_extracoverage)
                  fd.append("packageinsurance_coverage", packageinsurance_coverage)
                  if (packageinsurance_date_start === "") {
                        fd.append("packageinsurance_date_start", "")
                  } else {
                        fd.append(
                              "packageinsurance_date_start",
                              Moment(
                                    JDate.toGregorian(packageinsurance_date_start.year, packageinsurance_date_start.month, packageinsurance_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  if (packageinsurance_date_end === "") {
                        fd.append("packageinsurance_date_end", "")
                  } else {
                        fd.append(
                              "packageinsurance_date_end",
                              Moment(JDate.toGregorian(packageinsurance_date_end.year, packageinsurance_date_end.month, packageinsurance_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("packageinsurance_title", packageinsurance_title)
                  fd.append("packageinsurance_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("packageinsurance_company_id", selectedCompany.value)
                  fd.append("packageinsurance_deactive", packageinsurance_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/packageinsurance`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeManagDiscount = (imageCode) => {
            const {
                  packageinsurance_title,
                  packageinsurance_id,
                  packageinsurance_disctitle,
                  packageinsurance_discamount,
                  packageinsurance_amount,
                  packageinsurance_desc,
                  packageinsurance_extracoverage,
                  packageinsurance_coverage,
                  packageinsurance_date_start,
                  packageinsurance_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  packageinsurance_deactive,
            } = this.state
            if (
                  selectedFieldinsurance != "" &&
                  selectedCompany != "" &&
                  packageinsurance_title != "" &&
                packageinsurance_discamount != "" &&
                packageinsurance_amount != "" &&
                  packageinsurance_desc != "" &&
                  packageinsurance_coverage != ""  &&
                packageinsurance_extracoverage != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getManagDiscount()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_packageinsurance")
                  fd.append("packageinsurance_id", packageinsurance_id)
                  fd.append("packageinsurance_disctitle", packageinsurance_disctitle)
                  fd.append("packageinsurance_discamount", packageinsurance_discamount)
                  fd.append("packageinsurance_amount", packageinsurance_amount)
                  if(imageCode!=='') {
                        fd.append("packageinsurance_logo", imageCode)
                  }
                  fd.append("packageinsurance_desc", packageinsurance_desc)
                  fd.append("packageinsurance_extracoverage", packageinsurance_extracoverage)
                  fd.append("packageinsurance_coverage", packageinsurance_coverage)

                  if (packageinsurance_date_start === "") {
                        fd.append("packageinsurance_date_start", "")
                  } else {
                        fd.append(
                              "packageinsurance_date_start",
                              Moment(
                                    JDate.toGregorian(packageinsurance_date_start.year, packageinsurance_date_start.month, packageinsurance_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  if (packageinsurance_date_end === "") {
                        fd.append("packageinsurance_date_end", "")
                  } else {
                        fd.append(
                              "packageinsurance_date_end",
                              Moment(JDate.toGregorian(packageinsurance_date_end.year, packageinsurance_date_end.month, packageinsurance_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("packageinsurance_title", packageinsurance_title)
                  fd.append("packageinsurance_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("packageinsurance_company_id", selectedCompany.value)
                  fd.append("packageinsurance_deactive", packageinsurance_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/packageinsurance`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterManagDiscount = () => {
            const { selectedFilterFieldinsurance, selectedFilterCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterCompany.value === 0 || temparray[i].packageinsurance_company_id === selectedFilterCompany.value) &&
                        (selectedFilterFieldinsurance.value === 0 ||
                              temparray[i].packageinsurance_fieldinsurance_id === selectedFilterFieldinsurance.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.packageinsurance_date_end.year
                              ? this.state.packageinsurance_date_end.year +
                                "/" +
                                this.state.packageinsurance_date_end.month +
                                "/" +
                                this.state.packageinsurance_date_end.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.packageinsurance_date_start.year
                              ? this.state.packageinsurance_date_start.year +
                                "/" +
                                this.state.packageinsurance_date_start.month +
                                "/" +
                                this.state.packageinsurance_date_start.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  packageinsurance_title,
                  optionCompany,
                  optionFilterCompany,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newManagDiscount,
                  packageinsurance_id,
                  packageinsurance_disctitle,
                  packageinsurance_discamount,
                  packageinsurance_amount,
                  packageinsurance_t_logo,
                  packageinsurance_logo,
                  packageinsurance_desc,
                  packageinsurance_extracoverage,
                  packageinsurance_coverage,
                  packageinsurance_date_start,
                  packageinsurance_date_end,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  company_logo_url,
                  fieldinsurance_logo_url,
                  selectedCompany,
                  selectedFilterCompany,
                  packageinsurance_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره پکیج: " + packageinsurance_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt="Remy Sharp"
                                                                              className={classes.large}
                                                                              src={fieldinsurance_logo_url}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" className={classes.large} src={company_logo_url} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleFieldinsurance}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>

                                                                  <FloatingLabelInput
                                                                      placeholder="عنوان پکیج"
                                                                      handleInputt={this.handleGender}
                                                                      value={packageinsurance_title}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type={ "currency"}
                                                                        placeholder={"مبلغ پکبج " }
                                                                        handleInputt={this.handleChangeAmount}
                                                                        value={packageinsurance_amount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      type={ "currency"}
                                                                      placeholder={"مبلغ پکبج با تخفیف" }
                                                                      handleInputt={this.handleChangeDiscAmount}
                                                                      value={packageinsurance_discamount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      placeholder={"عنوان تخفیف" }
                                                                      handleInputt={this.handleChangeDiscTitle}
                                                                      value={packageinsurance_disctitle}
                                                                  />
                                                            </Grid>
                                                                  <Grid item xs={6}>
                                                                        <ImageUploader
                                                                            withIcon={true}
                                                                            buttonText="عکس را انتخاب نمایید"
                                                                            onChange={this.onSelectPicRequest}
                                                                            withPreview="true"
                                                                            singleImage="true"
                                                                            imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                            maxFileSize={5242880}
                                                                        />
                                                                  </Grid>
                                                            <Grid item xs={6}>
                                                            <img alt="" className={classes.large} src={packageinsurance_logo} />


                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات"
                                                                        handleInputt={this.handleChangeDesc}
                                                                        value={packageinsurance_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={packageinsurance_date_start}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پایان  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={packageinsurance_date_end}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="پوشش ها"
                                                                        handleInputt={this.handleChangeCovarage}
                                                                        value={packageinsurance_coverage}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                      placeholder="پوشش ها تکمیلی"
                                                                      handleInputt={this.handleChangeExtraCovarage}
                                                                      value={packageinsurance_extracoverage}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={packageinsurance_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت پکیج"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newManagDiscount ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت پکیج جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newManagDiscount}
                                                                              >
                                                                                    {"پکیج جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف پکیج"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFilterFieldinsurance}
                                                                              onChange={this.handleFilterFieldinsurance}
                                                                              options={optionFilterFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedFilterCompany}
                                                                              onChange={this.handleFilterCompany}
                                                                              options={optionFilterCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"packageinsurance_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "packageinsurance_id" ? order : false}
                                                                              >
                                                                                    {" آی دی تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "packageinsurance_id"}
                                                                                          direction={orderBy === "packageinsurance_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("packageinsurance_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>



                                                                              <TableCell
                                                                                    key={"fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" رشته بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
  <TableCell
                                                                                    key={"packageinsurance_title"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"  عنوان پکیج "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "packageinsurance_title"}
                                                                                          direction={orderBy === "packageinsurance_title" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("packageinsurance_title")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"packageinsurance_amount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"قیمت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "packageinsurance_amount"}
                                                                                          direction={orderBy === "packageinsurance_amount" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("packageinsurance_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"packageinsurance_discamount"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"قیمت با تخفیف"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "packageinsurance_discamount"}
                                                                                        direction={orderBy === "packageinsurance_discamount" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("packageinsurance_discamount")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"packageinsurance_t_logo"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پوشش پکیج"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "packageinsurance_coverage"}
                                                                                        direction={orderBy === "packageinsurance_coverage" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("packageinsurance_coverage")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"packageinsurance_extracoverage"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پوشش اضافی"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "packageinsurance_extracoverage"}
                                                                                        direction={orderBy === "packageinsurance_extracoverage" ? order : "asc"}
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("packageinsurance_extracoverage")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"packageinsurance_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت پکیج"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "packageinsurance_deactive"}
                                                                                          direction={
                                                                                                orderBy === "packageinsurance_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("packageinsurance_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["packageinsurance_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"packageinsurance_id"} align={"center"}>
                                                                                                      {row["packageinsurance_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                </TableCell>



                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>
                                                                                                 <TableCell key={"packageinsurance_title"} align={"center"}>
                                                                                                      {row["packageinsurance_title"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {
                                                                                                            <NumberFormat
                                                                                                                displayType={"text"}
                                                                                                                value={row["packageinsurance_amount"]}
                                                                                                                thousandSeparator={true}
                                                                                                                prefix={" ریال"}
                                                                                                            />
                                                                                                      }
                                                                                                </TableCell>


                                                                                                <TableCell align={"center"}>
                                                                                                      {
                                                                                                            <NumberFormat
                                                                                                                displayType={"text"}
                                                                                                                value={row["packageinsurance_discamount"]}
                                                                                                                thousandSeparator={true}
                                                                                                                prefix={" ریال"}
                                                                                                            />
                                                                                                      }
                                                                                                </TableCell>

                                                                                                <TableCell key={"packageinsurance_coverage"} align={"center"}>
                                                                                                      {row["packageinsurance_coverage"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"packageinsurance_extracoverage"} align={"center"}>
                                                                                                      {row["packageinsurance_extracoverage"]}
                                                                                                </TableCell>



                                                                                                <TableCell
                                                                                                      key={"packageinsurance_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["packageinsurance_deactive"] === "1" ||
                                                                                                      row["packageinsurance_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید پکیج را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePackageinsurance} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePackageinsurance)
